import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/de/ressourcen')({
  component: Outlet,
})
